<app-page-header
  title="Admin Test Dashboard"
  subtitle="Test the global loading component and other system features"
  icon="science"
  variant="gradient">
</app-page-header>

<div class="admin-test-container">
  <div class="test-grid">
    <!-- Global Loading Test Card -->
    <mat-card class="test-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <div class="nlc-icon-visual">
            <mat-icon>hourglass_empty</mat-icon>
          </div>
          Global Loading Test
        </mat-card-title>
        <mat-card-subtitle>
          Test the global loading spinner for 100 seconds
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <p>
          This test will activate the global loading component for exactly 100 seconds.
          You should see the spinning coin animation overlay the entire application.
        </p>

        <div class="test-actions">
          <button
            mat-flat-button
            class="nlc-button nlc-button-primary nlc-button-large"
            style="font-size: 15px;"
            [disabled]="isTestRunning"
            (click)="testGlobalLoading()">
            <mat-icon>play_arrow</mat-icon>
            Start 100-Second Test
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Multiple Loading Sources Test Card -->
    <mat-card class="test-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <mat-icon>layers</mat-icon>
          Multiple Sources Test
        </mat-card-title>
        <mat-card-subtitle>
          Test multiple loading sources (HTTP + Route)
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <p>
          This test simulates multiple loading sources being active simultaneously
          and ending at different times to test the loading service logic.
        </p>

        <div class="test-actions">
          <button
            mat-flat-button
            color="accent"
            [disabled]="isTestRunning"
            class="nlc-button nlc-button-primary nlc-button-large"
            style="font-size: 15px;"
            (click)="testMultipleLoadingSources()">
            <mat-icon>multiple_stop</mat-icon>
            Test Multiple Sources
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <!-- Rapid Toggle Test Card -->
    <mat-card class="test-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          <mat-icon>flash_on</mat-icon>
          Rapid Toggle Test
        </mat-card-title>
        <mat-card-subtitle>
          Test rapid on/off loading toggles
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <p>
          This test rapidly toggles the loading state on and off to ensure
          the component handles quick state changes gracefully.
        </p>

        <div class="test-actions">
          <button
            mat-flat-button
            class="nlc-button nlc-button-primary nlc-button-large"
            style="font-size: 15px;"
            color="warn"
            [disabled]="isTestRunning"
            (click)="testRapidToggle()">
            <mat-icon>speed</mat-icon>
            Test Rapid Toggle
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Test Progress and Results -->
  <mat-card class="results-card" *ngIf="testProgress > 0 || testResults.length > 0" appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>assessment</mat-icon>
        Test Results
      </mat-card-title>
      <mat-card-subtitle>
        Real-time test progress and logs
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <!-- Progress Bar -->
      <div class="progress-section" *ngIf="isTestRunning">
        <h3>Test Progress</h3>
        <mat-progress-bar
          mode="determinate"
          [value]="testProgress"
          color="primary">
        </mat-progress-bar>
        <span class="progress-text">{{ testProgress }}%</span>
      </div>

      <!-- Test Results Log -->
      <div class="results-section" *ngIf="testResults.length > 0">
        <div class="results-header">
          <h3>Test Log</h3>
          <button
            mat-icon-button
            color="warn"
            (click)="clearResults()"
            matTooltip="Clear Results">
            <mat-icon>clear</mat-icon>
          </button>
        </div>

        <div class="results-log">
          <div
            *ngFor="let result of testResults; let i = index"
            class="log-entry"
            [class.latest]="i === testResults.length - 1">
            {{ result }}
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Information Card -->
  <mat-card class="info-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <mat-icon>info</mat-icon>
        About Global Loading
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="info-grid">
        <div class="info-item">
          <h4>🎯 Purpose</h4>
          <p>The global loading component provides visual feedback during async operations like HTTP requests and route changes.</p>
        </div>

        <div class="info-item">
          <h4>🎨 Design</h4>
          <p>Features a spinning gold coin with "NLC" text, representing the NicLen Coins brand with smooth animations.</p>
        </div>

        <div class="info-item">
          <h4>⚙️ Implementation</h4>
          <p>Uses a centralized LoadingService that tracks multiple loading sources and shows/hides the overlay accordingly.</p>
        </div>

        <div class="info-item">
          <h4>🔧 Usage</h4>
          <p>Automatically triggered by HTTP interceptors and can be manually controlled via the LoadingService.</p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
